import { render, staticRenderFns } from "./DialogCadastroPontoTabela.vue?vue&type=template&id=3267b384&scoped=true&"
import script from "./DialogCadastroPontoTabela.vue?vue&type=script&lang=js&"
export * from "./DialogCadastroPontoTabela.vue?vue&type=script&lang=js&"
import style0 from "./DialogCadastroPontoTabela.vue?vue&type=style&index=0&id=3267b384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3267b384",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VForm,VLayout,VTextField})
